module.exports = __webpack_public_path__ + "static/media/Type_A_first_floor.9c31e9da.jpg";